export const eLetterParamsGL: (Submodule: any) => string[] = submodule => {
  let eLetterParamsArray: string[] = []

  // Common GL Header-Level Parameters
  const commonHeaderParams: string[] = [
    '[Description]',
    '[JournalNo]',
    '[JournalDate]',
    '[ReferenceNo]',
  ]

  // Common GL Item-Level Parameters
  const commonItemLevelParams: string[] = [
    '[Index]',
    '[AccDesc]',
    '[AccountCode]',
    '[Remark]',
    '[Dept]',
    '[DebitAmt]',
    '[CreditAmt]',
  ]

  const commonSummaryParams: string[] = ['[SumCreditAmt]', '[SumDebitAmt]']

  switch (submodule) {
    case 'JOURNAL_PROCESSING':
      return (eLetterParamsArray = [
        ...commonHeaderParams,
        '[FinancialYear]',
        '[FinancialPeriod]',
        '[JournalType]',
        ...commonItemLevelParams,
        ...commonSummaryParams,
      ])

    case 'AUDIT_ADJUSTMENT':
      return (eLetterParamsArray = [
        ...commonHeaderParams,
        '[AdjustmentType]',
        ...commonItemLevelParams,
        ...commonSummaryParams,
      ])
    case 'RECURRING_JOURNAL':
      return (eLetterParamsArray = [
        ...commonHeaderParams,
        '[StartYear]',
        '[StartPeriod]',
        '[JournalType]',
        ...commonItemLevelParams,
        ...commonSummaryParams,
      ])
  }
}
